module.exports = __webpack_public_path__ + "static/media/F.f25a1e14.jpg";